import axios from "axios";

axios.defaults.baseURL = "https://sgi.abiaphardistribution.com/backend/api/v1/";
axios.defaults.headers.common["Content-Type"] = "application/json";
axios.defaults.timeout = 30000;

// Interceptor de requête : injecte le token dynamiquement à chaque appel
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("user-token");
    if (token) {
      config.headers["user-token"] = token;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Interceptor de réponse : gestion globale des erreurs 401
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401 && 
        error.response.data.error === 'Token expiré. Veuillez vous reconnecter.') {
      localStorage.clear();
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);
